import { render } from "./SelectIngredientModal4.vue?vue&type=template&id=7cbc4ccc"
import script from "./SelectIngredientModal4.vue?vue&type=script&lang=js"
export * from "./SelectIngredientModal4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__